module.exports = __webpack_public_path__ + "static/media/gmail.992ac34a.svg";